module.exports = __webpack_public_path__ + "static/fb_icon-94c82deffa4c50e318e4db3528f734cd.png";